require.register("modules/m06/a02/page-17/page-17", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_17 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_17;


  
});

